import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Chip from '/@/components/bayer/chip';
import type { HelpCategory } from '/@/hooks/help-center';
import { _ } from '/@/locale';
import { ChipHelpCategoryIcon } from './help-category-icon';

type HelpCenterHomeCategoriesGridProps = {
    categories: HelpCategory[];
    selectedCategoryIds: ReadonlySet<number>;
    onToggleCategorySelection: (categoryId: number) => void;
};

export function HelpCenterHomeCategoriesGrid({
    categories,
    selectedCategoryIds,
    onToggleCategorySelection,
}: HelpCenterHomeCategoriesGridProps) {
    const theme = useTheme();

    return (
        <Stack direction='row' flexWrap='wrap' spacing={1} sx={{ width: '100%' }} useFlexGap>
            {categories.map((cat) => {
                const active = selectedCategoryIds.has(cat.id);
                return (
                    <Chip
                        icon={<ChipHelpCategoryIcon iconUrl={cat.iconUrl} selected={active} />}
                        key={cat.id}
                        selected={active}
                        onClick={() => onToggleCategorySelection(cat.id)}
                        label={_(cat.title)}
                    />
                );
            })}
        </Stack>
    );
}
